import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "yandex-map-3" }
const _hoisted_2 = { class: "yandex-map-3__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_yandex_map_provider = _resolveComponent("yandex-map-provider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_yandex_map_provider, {
        "script-src": _ctx.providerScriptSrc,
        id: _ctx.mapId,
        mode: _ctx.mode,
        "initial-map-center": _ctx.initialMapCenter,
        "initial-map-zoom": _ctx.initialMapZoom,
        "restrict-map-area": _ctx.restrictMapArea,
        onMapReady: _ctx.onMapReady,
        onMapDestroyed: _ctx.onMapDestroyed,
        onMapClicked: _ctx.onMapClicked
      }, null, 8, ["script-src", "id", "mode", "initial-map-center", "initial-map-zoom", "restrict-map-area", "onMapReady", "onMapDestroyed", "onMapClicked"])
    ])
  ]))
}